/**
 * @voltxampere/ui — MAX232 RS-232 level shifter variant (Sprint 49-6)
 *
 * Maxim/Texas Instruments TTL ↔ RS-232 voltage level converter
 * (DIP-16). Internal charge pump generates ±10V from a single 5V
 * supply, making it the standard solution for connecting embedded
 * systems with 5V TTL UART to PC serial ports.
 *
 * Requires 4 external 1µF capacitors for charge pump operation
 * (C1, C2, C3, C4 between V+ / V- / VS+ / VS- pins).
 *
 * Reference: Maxim MAX232 datasheet (rev 9, 2014); TI MAX232 (slls047).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const icMax232 = {
    id: "max232",
    nameTr: "MAX232 (TTL ↔ RS-232 Seviye Çevirici)",
    nameEn: "MAX232 (TTL ↔ RS-232 Level Shifter)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "MAX232",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        busType: "rs232-level-shifter",
        vendor: "Maxim",
        package: "DIP-16",
        voltageRangeV: { min: 4.5, max: 5.5 },
        rs232OutputV: { positive: 9, negative: -9 }, // typical with 1µF caps
        requiresExternalCaps: 4,
        capValueUf: 1.0,
        channelCount: 2, // 2 drivers + 2 receivers
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=ic-max232.js.map